import { Config } from '@cian/config';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { HelperContainer } from './containers/Helper';
import { IApplicationState, TReduxStore } from './types/redux';
import { createReduxStore } from './utils/store';

export interface IApplicationContext {
  config: Config;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  initialState: IApplicationState;
  fromNode?: boolean;
}

export type TApplicationСontextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export class Application extends React.Component<IApplicationProps> {
  public static childContextTypes: TApplicationСontextTypes = {
    // tslint:disable-next-line:no-any
    config: PropTypes.object as any,
    // tslint:disable-next-line:no-any
    logger: PropTypes.object as any,
  };

  private store: TReduxStore;

  public constructor(props: IApplicationProps) {
    super(props);

    this.store = createReduxStore(props.initialState, this.getChildContext(), !this.props.fromNode);
  }

  public getChildContext(): IApplicationContext {
    return {
      config: this.props.config,
      logger: this.props.logger,
    };
  }

  public render() {
    const { logger } = this.props;

    return (
      <ErrorLogComponent logger={logger}>
        <Provider store={this.store}>
          <HelperContainer />
        </Provider>
      </ErrorLogComponent>
    );
  }
}
